import { ScrollState } from 'hooks/useScrollArea';
import { FC, MutableRefObject, ReactNode } from 'react';

import ScrollArea, { ScrollAreaHandle } from '../scrollArea';
import SpaceDetails from './spaceDetails';

interface SpaceType {
  name: string;
  clinical: boolean;
}

interface Props {
  children?: ReactNode;
  space: SpaceType;
  times: string[];
  clinical?: boolean;
  setValue?: (value: object) => void;
  setTouched?: (touched: boolean) => void;
  onChange?: () => void;
  onRemove?: () => void;
  scrollRef?: MutableRefObject<ScrollAreaHandle>;
  scrollState?: ScrollState;
  changeLabel?: string;
  removeLabel?: string;
  detailsComponent?: typeof SpaceDetails;
}

const noOp = () => null;

const Space: FC<Props> = ({
  space,
  times,
  clinical,
  setValue = noOp,
  setTouched = noOp,
  onChange,
  onRemove,
  scrollRef,
  scrollState,
  children,
  changeLabel,
  removeLabel,
  detailsComponent: Details = SpaceDetails,
}) => {
  const usingSetters = clinical === undefined ? !space.clinical : !clinical;

  const selectTime = (startTime: string, endTime: string) => () => {
    if (usingSetters) {
      setTouched(true);
      setValue([{ startTime, endTime }]);
    }
  };

  return (
    <div className="calendar__space">
      <Details
        space={space}
        onChange={onChange}
        onRemove={onRemove}
        changeLabel={changeLabel}
        removeLabel={removeLabel}
      />
      <ScrollArea
        className="timeslot-widget__inner calendar__scroll-area"
        scrollbars={false}
        state={scrollState}
        horizontal
        ref={scrollRef}
      >
        <div className="timeslot-widget__content">
          <div className="times" data-testid="times">
            {times.map((time, index) => (
              <button
                type="button"
                key={time}
                className="time"
                onClick={selectTime(time, times[index + 2])}
              />
            ))}
          </div>
          {children}
        </div>
      </ScrollArea>
    </div>
  );
};

export default Space;
